import { EvidenceSessionList, QualityReportLink, useSiteMaterial } from 'features';
import { useTranslation } from 'i18n';
import { Suspense } from 'react';
import { ActionRow, Box, CardsListSkeleton, Grid, Page, Section, Typography } from 'ui';

import { ManageDataButton } from '../../components/ManageDataButton/ManageDataButton';
import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const QualityHome = () => {
  const { t } = useTranslation('orders');
  const { data } = useSiteMaterial();

  if (!data) {
    return <Typography>{t('qualityHomePage.materialNotFound')}</Typography>;
  }

  return (
    <Page>
      <Page.Title title={t('qualityHomePage.pageTitle')} />
      <Page.Divider />
      <Grid container>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <Section title={t('qualityHomePage.sections.siteDetails')}>
            <Box
              sx={{
                mb: 2,
              }}
            >
              <SiteHeader siteMaterial={data} />
            </Box>

            <ActionRow>
              <QualityReportLink siteMaterialPublicId={data.public_id} />
              <ManageDataButton />
            </ActionRow>
          </Section>
        </Grid>
        <Grid
          size={{
            md: 8,
            xs: 12,
          }}
        >
          <Section title={t('qualityHomePage.sections.sessions')}>
            <Suspense fallback={<CardsListSkeleton />}>
              <EvidenceSessionList siteMaterialId={data.id} defaultCollapsed />
            </Suspense>
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
